import React, { createContext, PropsWithChildren, useContext, useState } from 'react';
import { Workflow } from '@/app/workflows/actions/interfaces';

interface WorkflowContextValue {
  workflow: Workflow;
  getWorkflow: () => Workflow;
  setWorkflow: (workflow: Workflow) => void;
  resetWorkflow: () => void;
  updateWorkflowAttributes: (key: string, value: any) => void;
}

const WorkflowContext = createContext<WorkflowContextValue | undefined>(undefined);

export const WorkflowProvider: React.FC<
  PropsWithChildren<{
    initialWorkflow: Workflow;
  }>
> = ({ children, initialWorkflow }) => {
  const [workflow, setWorkflow] = useState<Workflow>(initialWorkflow);

  const getWorkflow = () => workflow;

  const resetWorkflow = () => {
    setWorkflow(initialWorkflow);
  };

  const updateWorkflowAttributes = (key: string, value: any) => {
    setWorkflow((prevWorkflow) => ({
      ...prevWorkflow,
      [key]: value,
    }));
  };

  const value: WorkflowContextValue = {
    workflow,
    getWorkflow,
    setWorkflow,
    resetWorkflow,
    updateWorkflowAttributes,
  };

  return <WorkflowContext.Provider value={value}>{children}</WorkflowContext.Provider>;
};

export const useWorkflow = (): WorkflowContextValue => {
  const context = useContext(WorkflowContext);
  if (!context) {
    throw new Error('useWorkflow must be used within a WorkflowProvider');
  }
  return context;
};
